class MegaMenuSidebar extends HTMLElement {
  constructor() {
    super();
    this.tabs = [];
    this.panels = [];
  }

  connectedCallback() {
    this.tabs = Array.from(this.querySelectorAll('.mega-menu__tab-link'));
    this.panels = Array.from(this.querySelectorAll('.mega-menu__panel'));

    this.tabs.forEach((tab) => {
      // Hover on desktop
      tab.addEventListener('mouseenter', () => this.switchTab(tab));

      // Focus for keyboard accessibility
      tab.addEventListener('focus', () => this.switchTab(tab));

      // Click: On touch devices, first tap activates tab; on second tap (or desktop click) it follows link
      tab.addEventListener('click', (e) => {
        const targetId = tab.getAttribute('data-tab-id');
        const activeItem = this.querySelector('.mega-menu__tab-item.is-active .mega-menu__tab-link');
        const isCurrentActive = activeItem && activeItem.getAttribute('data-tab-id') === targetId;

        if (!isCurrentActive && ('ontouchstart' in window || navigator.maxTouchPoints > 0)) {
          e.preventDefault();
          this.switchTab(tab);
        }
      });
    });

    // Keyboard navigation: ArrowUp and ArrowDown
    this.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
        const activeIndex = this.tabs.findIndex((t) =>
          t.closest('.mega-menu__tab-item').classList.contains('is-active')
        );
        if (activeIndex === -1) return;

        e.preventDefault();
        let nextIndex = e.key === 'ArrowDown' ? activeIndex + 1 : activeIndex - 1;
        if (nextIndex >= this.tabs.length) nextIndex = 0;
        if (nextIndex < 0) nextIndex = this.tabs.length - 1;

        const nextTab = this.tabs[nextIndex];
        if (nextTab) {
          nextTab.focus();
          this.switchTab(nextTab);
        }
      }
    });

    // Reset to default active tab when mega-menu details opens
    const details = this.closest('details');
    if (details) {
      details.addEventListener('toggle', () => {
        if (details.open) {
          const defaultTab =
            this.querySelector('.mega-menu__tab-item[data-default-active="true"] .mega-menu__tab-link') ||
            this.tabs[0];
          if (defaultTab) {
            this.switchTab(defaultTab);
          }
        }
      });
    }
  }

  switchTab(activeTab) {
    const targetPanelId = activeTab.getAttribute('data-tab-id');
    const parentItem = activeTab.closest('.mega-menu__tab-item');

    // Update tabs
    this.querySelectorAll('.mega-menu__tab-item').forEach((item) => {
      const link = item.querySelector('.mega-menu__tab-link');
      if (item === parentItem) {
        item.classList.add('is-active');
        link?.setAttribute('aria-selected', 'true');
      } else {
        item.classList.remove('is-active');
        link?.setAttribute('aria-selected', 'false');
      }
    });

    // Update panels
    this.panels.forEach((panel) => {
      if (panel.id === targetPanelId) {
        panel.classList.add('is-active');
      } else {
        panel.classList.remove('is-active');
      }
    });
  }
}

if (!customElements.get('mega-menu-sidebar')) {
  customElements.define('mega-menu-sidebar', MegaMenuSidebar);
}
